import * as PIXI from "pixi.js";
import SoundManager from "../../managers/SoundManager";
import FireworkBody from "./FireworkBody";
import String from "./String";
import Explosion from "./Explosion";
import Fire from "./Fire";
import WinAnimation from "../../animations/WinAnimation";
import { FireworksColor } from "../../types/Enum";


export default class Firework extends PIXI.Container {

  private FireworkBody: FireworkBody;
  private String: String;
  private Explosion:Explosion;
  private Fire:Fire;
  wIconIndex: number = -1 //0-4
  gridCoord: string;//0x2 1x3
  index: number;
  animation: WinAnimation;

  constructor(index: number, x: number, y: number, cI: number, rI: number) {
    super()
    this.index = index;
    this.x = x;
    this.y = y;
    this.scale.set(.9)
    this.Explosion = new Explosion(this);
    this.setGridCoord(cI, rI);
    this.addFire();
    this.addString();
    this.setTail(false);
    this.addFireworkBody();
    this.setInteractivity(true);
    this.animation = new WinAnimation(this);
    this.on("mousedown", this.handleMousedown);
    this.on("touchstart", this.handleMousedown);
  }

  generateAssetsPath = (colorName: FireworksColor | "empty") => `./images/explosion/explosion_${colorName}.png`;
  setWinIconIndex = (index: number) => this.wIconIndex = index;
  getWinIconIndex = () => this.wIconIndex;
  startAnimation = () => this.animation && this.animation.start();
  stopAnimation = () => this.animation && this.animation.stop();
  addFireworkBody() {
    this.FireworkBody = new FireworkBody(this.index);
    this.addChild(this.FireworkBody)
  }
  setTail(showString:boolean){
    if(showString){
      this.String.visible = true;
      this.Fire.visible = false;
      return
    }
    this.String.visible = false;
    this.Fire.visible = true;
  }
  addFire(){
    this.Fire = new Fire();
    this.addChild(this.Fire);
  }
  addString() {
    this.String = new String();
    this.addChild(this.String);
  }
  setInteractivity(v: boolean) {
    this.interactive = v;
    this.cursor = v ? "pointer" : "default";
  }
  handleMousedown() {
    this.explode()
    this.wIconIndex == -1 && SoundManager.play(SoundManager.soundName.clickOnBadFirework, false, .05);
  }
  hideFirework(){
    this.String.alpha = 0;
    this.FireworkBody.alpha = 0;
  }
  explode() {
    this.setInteractivity(false);
    this.String.runAnimation(() => this.Explosion.run());
  }
  setGridCoord(columnIndex: number, rowIndex: number) {
    this.gridCoord = `${columnIndex}x${rowIndex}`;
  }
  getGridCoord() {
    const [column, row] = this.gridCoord.split("x");
    return { c: column, r: row }
  }
  remove() {
    this.animation && this.animation.stop();
    this.parent.removeChild(this);
    this.destroy();
  }
}
